<template>
  <div>
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="row">
            <div class="form-group col-sm-12">
              <ul class="navbar-nav overflow-auto flex-row gap-4">
                <li v-for="(value, tab) in visibleTabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                  <a href="#" @click.prevent="selectTab(value)" class="nav-link tab" :class="{'active': activeTabName === value}">{{ helper.trans(`system_settings.tab.${tab}`) }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <SystemSettingsGeneral v-if="activeTabName === Tabs.general"></SystemSettingsGeneral>
      <PaymentPageSettings v-if="activeTabName === Tabs.paymentInstructions"></PaymentPageSettings>
    </div>
  </div>
</template>
<script lang="ts">
import {computed, defineComponent, toRefs, reactive} from 'vue'
import {helper} from "@/service/CommonHelper";
import router from "@/router";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {UserPermission} from "@/models/enum/UserPermission";
import SystemSettingsGeneral from "@/views/SystemSettingsGeneral.vue";
import PaymentPageSettings from "@/views/PaymentPageSettings.vue";

enum Tabs {
  general = 'general',
  paymentInstructions = 'paymentInstructions',
}

export default defineComponent({
  name: 'SystemSettings',
  components: {
    SystemSettingsGeneral,
    PaymentPageSettings,
  },
  setup() {
    const route = useRoute()
    const store = useStore()

    const visibleTabs = computed(() => {
      const tabs: Partial<Record<Tabs, Tabs>> = {}
      if (store.getters.hasPermission(UserPermission.EDIT_SETTINGS)) {
        tabs[Tabs.general] = Tabs.general
      }
      if (store.getters.hasPermission(UserPermission.EDIT_SETTINGS_PAYMENT_PAGE)) {
        tabs[Tabs.paymentInstructions] = Tabs.paymentInstructions
      }
      return tabs
    })

    const defaultTab = Object.values(visibleTabs.value)[0]
    const state = reactive({
      activeTabName: (!route.params.tab ? defaultTab : route.params.tab) as Tabs,
    });

    const selectTab = async (value: string) => {
      router.push(`/system-settings/${value}`)
      state.activeTabName = value as Tabs
    }

    return {
      ...toRefs(state),
      helper,
      Tabs,
      visibleTabs,
      selectTab
    }
  }
})
</script>
